module.exports = __webpack_public_path__ + "img/paypal.93488e1.svg";